module.exports = ".titles{\r\n    width: 15rem;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/a0120-contract-company/contract-company.component.css
// module id = ./src/app/a0120-contract-company/contract-company.component.css
// module chunks = main